/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/** Screen name passed to /v1/smart-carousel/screens/{screenName}. */
export const CAROUSEL_SCREEN_NAME: string = "recommendations";

/** Number of carousel rails requested per screenGet call. */
export const CAROUSEL_PAGE_SIZE: number = 3;

/**
 * Distance from the last loaded rail at which a load-more screenGet
 * fetch should be triggered.
 */
export const CAROUSEL_RAIL_PREFETCH_THRESHOLD: number = 2;

/**
 * Distance from the last loaded tile at which a load-more carouselGet
 * fetch should be triggered. Higher threshold starts prefetch earlier,
 * giving more time for the network request to complete before tiles run out.
 */
export const CAROUSEL_TILE_PREFETCH_THRESHOLD: number = 5;

/**
 * Number of carousel rails to render above and below the focused rail.
 * Rails outside this window are not rendered (lazy loading).
 * Buffer of 3 provides smooth vertical navigation without visible pop-in.
 */
export const CAROUSEL_RAIL_RENDER_BUFFER: number = 3;

/** Logging screen identifier for the Home screen carousel API endpoint. */
export const HOMESCREEN_CAROUSEL_SCREEN_ID: string = "/screens/unityHome";

/** Human-readable screen label used in analytics events for the Home screen. */
export const HOMESCREEN_CAROUSEL_SCREEN_NAME: string = "Home";

/** API endpoint name used in operational apiRequest events for the Home screen. */
export const HOMESCREEN_CAROUSEL_API_ENDPOINT: string = "/screens/unityHome";
